import ContactInfo from "@/models/contact-info";

export default class Payer extends ContactInfo {
  constructor(data = {}) {
    super(data);
    this.userId = data.userId;
    this.email = data.email;
    this.paymentMethods = data.paymentMethods || [];
    this.payerProfiles = data.payerProfiles || [];
  }
}
